import type { PropsWithChildren } from 'react'

import { PortalV2Layout } from './PortalV2Layout'

export interface PortalLayoutProps {
  classNameContainerChildren?: string
  classNameNavbar?: string
  className?: string
  classNameMain?: string
}

const PortalLayout = ({
  children,
  classNameContainerChildren,
  classNameNavbar,
  className,
  classNameMain
}: PropsWithChildren<PortalLayoutProps>) => {
  return (
    <PortalV2Layout
      className={className}
      classNameMain={classNameMain}
      classNameContainerChildren={classNameContainerChildren}
      classNameNavbar={classNameNavbar}
    >
      {children}
    </PortalV2Layout>
  )
}

export default PortalLayout
